  let mvStep = 1;
  let mvTimerInterval = null;
  let mvSeconds = 0;
  // Selected country state
  let mvSelectedCountry = {
    name: "India",
    dialCode: "+91",
    flag: "🇮🇳"
  };
  // Country data (sample full-ish list; extend as needed)
  const MV_COUNTRIES = [{
      name: "India",
      dialCode: "+91",
      flag: "🇮🇳"
    }, {
      name: "United States",
      dialCode: "+1",
      flag: "🇺🇸"
    }, {
      name: "United Kingdom",
      dialCode: "+44",
      flag: "🇬🇧"
    }, {
      name: "United Arab Emirates",
      dialCode: "+971",
      flag: "🇦🇪"
    }, {
      name: "Singapore",
      dialCode: "+65",
      flag: "🇸🇬"
    }, {
      name: "Australia",
      dialCode: "+61",
      flag: "🇦🇺"
    }, {
      name: "Canada",
      dialCode: "+1",
      flag: "🇨🇦"
    }, {
      name: "Germany",
      dialCode: "+49",
      flag: "🇩🇪"
    }, {
      name: "France",
      dialCode: "+33",
      flag: "🇫🇷"
    }, {
      name: "Italy",
      dialCode: "+39",
      flag: "🇮🇹"
    }, {
      name: "Spain",
      dialCode: "+34",
      flag: "🇪🇸"
    }, {
      name: "Switzerland",
      dialCode: "+41",
      flag: "🇨🇭"
    }, {
      name: "Thailand",
      dialCode: "+66",
      flag: "🇹🇭"
    }, {
      name: "Japan",
      dialCode: "+81",
      flag: "🇯🇵"
    }, {
      name: "China",
      dialCode: "+86",
      flag: "🇨🇳"
    }, {
      name: "Hong Kong",
      dialCode: "+852",
      flag: "🇭🇰"
    }, {
      name: "Qatar",
      dialCode: "+974",
      flag: "🇶🇦"
    }, {
      name: "Saudi Arabia",
      dialCode: "+966",
      flag: "🇸🇦"
    }, {
      name: "New Zealand",
      dialCode: "+64",
      flag: "🇳🇿"
    }, {
      name: "Malaysia",
      dialCode: "+60",
      flag: "🇲🇾"
    }, {
      name: "Indonesia",
      dialCode: "+62",
      flag: "🇮🇩"
    }, {
      name: "Philippines",
      dialCode: "+63",
      flag: "🇵🇭"
    }, {
      name: "Netherlands",
      dialCode: "+31",
      flag: "🇳🇱"
    }, {
      name: "Belgium",
      dialCode: "+32",
      flag: "🇧🇪"
    }, {
      name: "Austria",
      dialCode: "+43",
      flag: "🇦🇹"
    }, {
      name: "Ireland",
      dialCode: "+353",
      flag: "🇮🇪"
    }, {
      name: "Portugal",
      dialCode: "+351",
      flag: "🇵🇹"
    }, {
      name: "Greece",
      dialCode: "+30",
      flag: "🇬🇷"
    }, {
      name: "Turkey",
      dialCode: "+90",
      flag: "🇹🇷"
    }, {
      name: "South Africa",
      dialCode: "+27",
      flag: "🇿🇦"
    }, {
      name: "Brazil",
      dialCode: "+55",
      flag: "🇧🇷"
    }, {
      name: "Mexico",
      dialCode: "+52",
      flag: "🇲🇽"
    }, {
      name: "Sri Lanka",
      dialCode: "+94",
      flag: "🇱🇰"
    }, {
      name: "Nepal",
      dialCode: "+977",
      flag: "🇳🇵"
    }, {
      name: "Bangladesh",
      dialCode: "+880",
      flag: "🇧🇩"
    }, {
      name: "Pakistan",
      dialCode: "+92",
      flag: "🇵🇰"
    }, {
      name: "Vietnam",
      dialCode: "+84",
      flag: "🇻🇳"
    }, {
      name: "Maldives",
      dialCode: "+960",
      flag: "🇲🇻"
    }, {
      name: "Oman",
      dialCode: "+968",
      flag: "🇴🇲"
    }, {
      name: "Kuwait",
      dialCode: "+965",
      flag: "🇰🇼"
    }, {
      name: "Bahrain",
      dialCode: "+973",
      flag: "🇧🇭"
    }, {
      name: "Egypt",
      dialCode: "+20",
      flag: "🇪🇬"
    }, {
      name: "Kenya",
      dialCode: "+254",
      flag: "🇰🇪"
    }, {
      name: "Nigeria",
      dialCode: "+234",
      flag: "🇳🇬"
    },
    // Add more if required
  ];

  function renderCountryList(filter = "") {
    const listEl = document.getElementById("mv-country-list");
    listEl.innerHTML = "";
    const query = filter.trim().toLowerCase();
    const filtered = MV_COUNTRIES.filter((c) => {
      if (!query) return true;
      return (c.name.toLowerCase().includes(query) || c.dialCode.toLowerCase().includes(query));
    });
    filtered.forEach((c) => {
      const li = document.createElement("li");
      li.className = "mv-country-item";
      li.innerHTML = `
 
		<span class="mv-country-flag">${c.flag}</span>
		<span>${c.name}</span>
		<span class="mv-country-dial">${c.dialCode}</span>
 `;
      li.addEventListener("click", () => selectCountry(c));
      listEl.appendChild(li);
    });
    if (!filtered.length) {
      const li = document.createElement("li");
      li.className = "mv-country-item";
      li.textContent = "No matches";
      li.style.color = "#9ca3af";
      listEl.appendChild(li);
    }
  }

  function selectCountry(country) {
    mvSelectedCountry = country;
    document.getElementById("mv-country-flag").textContent = country.flag;
    document.getElementById("mv-country-name").textContent = country.name;
    document.getElementById("mv-country-dial").textContent = country.dialCode;
    closeCountryDropdown();
  }

  function toggleCountryDropdown() {
    const dd = document.getElementById("mv-country-dropdown");
    const isOpen = dd.classList.contains("is-open");
    if (isOpen) {
      closeCountryDropdown();
    } else {
      dd.classList.add("is-open");
      document.getElementById("mv-country-search").value = "";
      renderCountryList("");
      setTimeout(() => {
        document.getElementById("mv-country-search").focus();
      }, 0);
    }
  }

  function closeCountryDropdown() {
    document.getElementById("mv-country-dropdown").classList.remove("is-open");
  }
  document.addEventListener("click", function(e) {
    const wrapper = document.querySelector(".mv-country-wrapper");
    if (!wrapper) return;
    if (!wrapper.contains(e.target)) {
      closeCountryDropdown();
    }
  });
  document.addEventListener("input", function(e) {
    if (e.target.id === "mv-country-search") {
      renderCountryList(e.target.value);
    }
  });

  function resetBtn() {
    const btn = document.getElementById("mv-primary-btn");
    const label = document.getElementById("mv-primary-label");
    btn.disabled = false;

    if (mvStep === 1) {
      label.textContent = "Send Verification Code";
    } else {
      label.textContent = "Verify Code";
    }
  }

  function showServerError(msg) {
    const el = document.getElementById("mv-server-error");
    el.textContent = msg;
    el.classList.add("is-visible");
  }

  function clearServerError() {
    document.getElementById("mv-server-error").classList.remove("is-visible");
  }

  function openMobileVerification() {
    console.log("Running otp modal")
    const bd = document.getElementById("mv-backdrop");
    bd.classList.add("is-open");
    bd.setAttribute("aria-hidden", "false");
    mvStep = 1;
    resetForm();
  }

//   function openMobileVerification() {
//     console.log("Running otp modal")
//     const bd = document.getElementById("mv-backdrop");
//     bd.classList.add("is-open");
//     bd.setAttribute("aria-hidden", "false");
//     mvStep = 1;
//     resetForm();
//   }

  function closeMobileVerification() {
    const bd = document.getElementById("mv-backdrop");
    bd.classList.remove("is-open");
    bd.setAttribute("aria-hidden", "true");
    stopTimer();
  }

  function resetForm() {
    document.getElementById("mv-mobile").value = "";
    document.getElementById("mv-otp-section").style.display = "none";
    document.getElementById("mv-error").classList.remove("is-visible");
    document.getElementById("mv-primary-label").textContent = "Send Verification Code";
    document.getElementById("mv-timer").textContent = "";
    document.querySelectorAll(".mv-otp-input").forEach((el) => (el.value = ""));
  }

  function showError(msg) {
    const err = document.getElementById("mv-error");
    err.textContent = msg;
    err.classList.add("is-visible");
  }

  function clearError() {
    document.getElementById("mv-error").classList.remove("is-visible");
  }

  function onPrimaryAction() {
    if (mvStep === 1) {
      handleSendOtp();
    } else {
      handleVerifyOtp();
    }
  }

  function handleSendOtp() {
    clearError();
    clearServerError();

    const btn = document.getElementById("mv-primary-btn");
    const label = document.getElementById("mv-primary-label");

    const mobileEl = document.getElementById("mv-mobile");
    const mobile = $('#mv-country-dial').html().replace('+','') + mobileEl.value.trim().replace(/\s+/g, "");
    // Generic validation: 5–15 digits
    if (!/^\d{5,15}$/.test(mobile)) {
      showError("Please enter a valid mobile number (digits only).");
      return;
    }
    btn.disabled = true;
    label.textContent = "Sending…";
    sendOtp(mobile, "", "")
    .done(function (res) {
      if (res.success === true) {
        $("#finalOtp").data("otpId", res.otpId);

        document.getElementById("mv-otp-section").style.display = "block";

        const btn = document.getElementById("mv-primary-btn");
        const label = document.getElementById("mv-primary-label");

        label.textContent = "Verify Code";
        btn.disabled = false;   // ✅ re-enable button

        mvStep = 2;
        startTimer(60);

        const firstOtp = document.querySelector(".mv-otp-input");
        if (firstOtp) firstOtp.focus();
      } else {
        showServerError(res.message || "Failed to send verification code.");
        resetBtn();
      }
    })

    .fail(function () {
      showServerError("Could not connect to server. Try again.");
      resetBtn();
    });
  }

  function showSuccessScreen() {
    // Hide other UI
    document.querySelector(".mv-field-group").style.display = "none";
    document.getElementById("mv-otp-section").style.display = "none";
    document.querySelector(".mv-actions").style.display = "none";
    clearServerError();
    clearError();

    // Show success
    document.getElementById("mv-success").style.display = "block";

    // start reload after 1.5 second
    // setTimeout(() => {
    //   window.location.reload();
    // }, 2000);
    // close popup after 3 second
    setTimeout(() => {
      closeMobileVerification();
    }, 4000);
  }


  function handleVerifyOtp() {
    const btn = document.getElementById("mv-primary-btn");
    const label = document.getElementById("mv-primary-label");

    clearServerError();
    clearError();
    const digits = [];
    document.querySelectorAll(".mv-otp-input").forEach((el) => digits.push(el.value.trim()));
    const otp = digits.join("");
    // 4-digit OTP
    if (!/^\d{4}$/.test(otp)) {
      showError("Please enter the 4-digit OTP.");
      return;
    }
    btn.disabled = true;
    label.textContent = "Verifying…";
    const mobileEl = document.getElementById("mv-mobile");
    const mobile = $('#mv-country-dial').html().replace('+','') + mobileEl.value.trim().replace(/\s+/g, "");
    const otpId = $("#finalOtp").data("otpId");
    verifyOtp(otp, otpId, mobile)
    .done(function (res) {
      if (res.success === true) {
        // {% comment %} saveCustomerInfoCart(); {% endcomment %}
        saveToGoogleSheet(mobile);
        localStorage.setItem("isMatrixVisaPopupFilled", true);
        localStorage.setItem("isMatrixVisaThemePopupFilled", true);
        showSuccessScreen();
      } else {
        showServerError("Invalid OTP. Please try again.");
        resetBtn();
      }
    })
    .fail(function () {
      showServerError("Could not verify OTP. Please try again.");
      resetBtn();
    });

  }
  // Simple resend countdown
  function startTimer(seconds) {
    stopTimer();
    mvSeconds = seconds;
    updateTimerLabel();
    mvTimerInterval = setInterval(() => {
      mvSeconds--;
      if (mvSeconds <= 0) {
        stopTimer();
        $("#mv-timer").html(`Didn't get the code? <a href="javascript:void(0)" onclick="handleResendOtp()">Resend Verification Code</a>`);
      } else {
        updateTimerLabel();
      }
    }, 1000);
  }

  function stopTimer() {
    if (mvTimerInterval) {
      clearInterval(mvTimerInterval);
      mvTimerInterval = null;
    }
  }

  function updateTimerLabel() {
    const label = document.getElementById("mv-timer");
    label.textContent = `You can resend verification code in ${mvSeconds}s`;
  }

  function handleResendOtp() {
    const mobileEl = document.getElementById("mv-mobile");
    const mobile = $('#mv-country-dial').html().replace('+','') + mobileEl.value.trim().replace(/\s+/g, "");
    sendOtp(mobile, "", "").done(function(res) {
      if (res.success === true) {
        // Hide form, show OTP section
        // Store OTP Id
        $("#finalOtp").data("otpId", res.otpId);
        const firstOtp = document.querySelector(".mv-otp-input");
        if (firstOtp) {
          firstOtp.focus();
        }
      } else {
        resetBtn();
        alert(res.message || "Verification Code failed");
      }
    });
    startTimer(60);
  }
  // Auto-focus next OTP box
  document.addEventListener("input", function(e) {
    if (e.target.classList.contains("mv-otp-input")) {
      const input = e.target;
      if (input.value.length === input.maxLength) {
        const next = input.nextElementSibling;
        if (next && next.classList.contains("mv-otp-input")) {
          next.focus();
        }
      }
    }
  });
  // Close on ESC
  document.addEventListener("keydown", function(e) {
    if (e.key === "Escape") {
    //   {% comment %} closeMobileVerification(); {% endcomment %}
    }
  });
  // Init country list on load
  document.addEventListener("DOMContentLoaded", () => {
    renderCountryList("");
  });

 

//   {% comment %} $(document).ready(function() {
   
//       if (!localStorage.getItem("isMatrixVisaPopupFilled")) {
//         setTimeout(function() {
//           openMobileVerification();
//         }, 500);
//       }
    
//   }) {% endcomment %}
  
  let isSendingOtp = false;

  function sendOtp(phone, email, name) {
    if (isSendingOtp) return; // stop rapid hits
    isSendingOtp = true;
    const formData = new FormData();
    formData.append("email", email);
    formData.append("firstName", name);
    formData.append("phone", phone);
    return $.ajax({
      url: "https://azcms.matrix.co.in/shopify/matrix/sendOtp",
      method: "POST",
      processData: false,
      contentType: false,
      data: formData
    }).done(function(res) {
      console.log("OTP response", res);
    }).fail(function(xhr) {
      console.log("OTP Send Error:", xhr.responseText);
    }).always(function() {
      isSendingOtp = false; // allow OTP to be sent again
    });
  }

  function verifyOtp(otp, otpId, phone) {
    const formData = new FormData();
    formData.append("otp", otp);
    formData.append("otpId", otpId);
    formData.append("phone", phone);
    return $.ajax({
      url: "https://azcms.matrix.co.in/shopify/matrix/verifyOtp",
      method: "POST",
      processData: false,
      contentType: false,
      data: formData
    });
  }

  function saveCustomerInfoCart(){
    console.log("saving the user details");
    let name = "Test";
    const mobileEl = document.getElementById("mv-mobile");
    const mobile = mobileEl.value.trim().replace(/\s+/g, "");
    let phone = $('#mv-country-dial').html().replace('+','') + mobile;
    let email = "test@example.com"
    let country = localStorage.getItem("affiliateName", "Test");
    if (country == null || country === undefined || country == ""){
      country = "Test"
    }
    
    var settings = {
      "url": "https://azcms.matrix.co.in/shopify/api/matrixindiastore/saveCustomerInfo", //"https://tab.matrix.in/ShopAPI/api/Values/InsertCustomerInfo",
      "method": "POST",
      "headers": {
        "Content-Type": "application/json"
      },
      "data": JSON.stringify({
        "Name": name,
        "Email": email,
        "MobileNo": phone,
        "Country": country,
        "affiliateName": localStorage.getItem("affiliateName", "")
      }),
    };

    // {% comment %} $('#myModal').modal('hide'); {% endcomment %}
    
    $.ajax(settings).done(function (response) {
      if (response.success == 1){
        localStorage.setItem("isMatrixVisaPopupFilled", true);
        localStorage.setItem("isMatrixVisaThemePopupFilled", true);
      }
    });
    
  }

  function saveToGoogleSheet(phone){

    const URL="https://script.google.com/macros/s/AKfycbxAqNTK0KRoy5hXxAw7Xl9J7th1k4qVC4Anf8BjrwtV0ETm3bIYfjMD7UlV1x316CQ38A/exec";
     const data = {
      phone: phone
    };

    fetch(URL, {
      method: "POST",
      mode: "no-cors",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    })
    .then(() => console.log("success saved to excel")).catch((e)=> console.log("Error saving into sheet",e))

  }